var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "investment-research"
  }, [_c("section", {
    staticClass: "investment-research__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "智能投研",
      description: "同花顺智能投研系统在金融大数据的支持下，通过机器学习、深度学习、NLP等AI技术，对数据、资讯事件、观点逻辑等信息进行自动化处理和分析，\n      高效处理全网信息，智能辅助成果生产，提高分析师、基金经理等从业人员的投工作效率和投研能力。",
      productId: _vm.productId
    }
  })], 1), _c("section", {
    staticClass: "investment-research__function-wrapper"
  }, [_c("Function")], 1), _c("section", {
    staticClass: "investment-research__scene-wrapper"
  }, [_c("Scene")], 1), _c("section", {
    staticClass: "investment-research__features-wrapper"
  }, [_c("Features", {
    attrs: {
      featuresList: _vm.featuresList
    }
  })], 1), _c("section", {
    staticClass: "investment-research__cases-wrapper"
  }, [_c("Cases")], 1), _c("section", {
    staticClass: "investment-research__appointment-wrapper"
  }, [_c("Appointment2", {
    attrs: {
      productId: _vm.productId
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };